import React from 'react';
import { Box, Container } from '@mui/material';
import { motion } from 'framer-motion';

const stats = [
  { num: '2', label: 'Years Experience' },
  { num: 'React\nNode\nCloud', label: 'Tech Stack' },
  { num: '1', label: 'Live Client' },
  { num: 'Full\nStack', label: 'Role' },
];

const AboutSection = () => (
  <Box id="about" component="section" sx={{ borderBottom: '1px solid #1E3040' }}>
    <Container maxWidth="lg" sx={{ py: { xs: 8, md: 12 } }}>
      <Box sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
        gap: { xs: 8, md: 10 },
        alignItems: 'center',
      }}>
        {/* Left: photo + stats grid */}
        <motion.div
          initial={{ opacity: 0, x: -24 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true, margin: '-80px' }}
        >
          <Box sx={{ position: 'relative' }}>
            <Box sx={{
              position: 'absolute', top: -20, left: -20,
              width: 56, height: 56,
              border: '1px solid rgba(255,145,77,0.2)',
              transform: 'rotate(10deg)',
              zIndex: 0,
            }} />
            <Box
              component="img"
              src="images/EricRakHero.png"
              alt="Eric Rak"
              sx={{
                width: '100%',
                maxWidth: '420px',
                display: 'block',
                border: '1px solid #2A4560',
                position: 'relative',
                zIndex: 1,
                filter: 'grayscale(15%)',
              }}
            />
            <Box sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: '1px',
              background: '#1E3040',
              mt: '1px',
            }}>
              {stats.map((s) => (
                <Box key={s.label} sx={{ background: '#162333', p: 3 }}>
                  <Box sx={{
                    fontFamily: "'Anton', sans-serif",
                    fontSize: s.num.includes('\n') ? '18px' : '36px',
                    color: '#FF914D', lineHeight: 1.2,
                    whiteSpace: 'pre-line',
                  }}>
                    {s.num}
                  </Box>
                  <Box sx={{
                    fontSize: '9px', letterSpacing: '2px', textTransform: 'uppercase',
                    color: '#7A9AB0', fontFamily: "'Barlow', sans-serif", mt: 0.5,
                  }}>
                    {s.label}
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        </motion.div>

        {/* Right: copy */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          viewport={{ once: true, margin: '-80px' }}
        >
          <Box sx={{
            fontSize: '10px', letterSpacing: '4px', textTransform: 'uppercase',
            color: '#FF914D', fontFamily: "'Barlow', sans-serif", mb: 2,
            display: 'flex', alignItems: 'center', gap: 1.5,
            '&::before': { content: '""', display: 'block', width: '24px', height: '1px', background: '#FF914D' },
          }}>
            About
          </Box>
          <Box component="h2" sx={{
            fontFamily: "'Anton', sans-serif",
            fontSize: { xs: '48px', md: '60px' },
            textTransform: 'uppercase', lineHeight: 0.92,
            color: '#F0EEE8', m: 0, mb: 4,
          }}>
            Who<br />I Am
          </Box>
          {[
            <React.Fragment key="p1">I'm <Box component="strong" sx={{ color: '#F0EEE8', fontStyle: 'normal', fontWeight: 400 }}>Eric Rak</Box>, a full-stack developer focused on helping small businesses compete in the digital landscape — without enterprise budgets.</React.Fragment>,
            <React.Fragment key="p2">I build <Box component="strong" sx={{ color: '#F0EEE8', fontStyle: 'normal', fontWeight: 400 }}>clean, fast, and maintainable</Box> digital products. From simple marketing sites to cloud-connected applications, I take projects from idea to launch.</React.Fragment>,
            <React.Fragment key="p3">Based in <Box component="strong" sx={{ color: '#F0EEE8', fontStyle: 'normal', fontWeight: 400 }}>Toronto</Box>, working with clients locally and remotely.</React.Fragment>,
          ].map((text, i) => (
            <Box key={i} component="p" sx={{
              fontFamily: "'Source Serif 4', Georgia, serif",
              fontStyle: 'italic', fontWeight: 300,
              fontSize: '17px', color: '#7A9AB0', lineHeight: 1.8, m: 0, mb: 3,
            }}>
              {text}
            </Box>
          ))}
          <Box
            component="button"
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            sx={{
              mt: 1,
              background: '#FF914D', color: '#0D1821',
              border: 'none', px: 4, py: 1.75,
              fontSize: '11px', letterSpacing: '3px', textTransform: 'uppercase',
              fontFamily: "'Barlow', sans-serif", fontWeight: 400,
              cursor: 'pointer', transition: 'opacity 0.2s',
              '&:hover': { opacity: 0.85 },
            }}
          >
            Get In Touch
          </Box>
        </motion.div>
      </Box>
    </Container>
  </Box>
);

export default AboutSection;
